export function heatHue(sim: number): number {
  const s = Math.max(0, Math.min(1, sim));
  if (s < 0.85) return 220 - (s / 0.85) * 220;
  return ((s - 0.85) / 0.15) * 50;
}

export function heatColor(sim: number, alpha = 1): string {
  const hue = heatHue(sim);
  return `hsla(${hue}, 78%, 58%, ${alpha})`;
}

export function heatLabel(sim: number): string {
  if (sim >= 0.99) return "exact";
  if (sim >= 0.85) return "boiling";
  if (sim >= 0.7) return "hot";
  if (sim >= 0.55) return "warm";
  if (sim >= 0.4) return "tepid";
  if (sim >= 0.25) return "cool";
  return "cold";
}

export function formatSim(sim: number): string {
  return (sim * 100).toFixed(2);
}
